import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const FleetApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "Fleet" */ "./FleetApp");
    return { default: namedExport.FleetApp };
});

export const Fleet: TeamAppConfig = {
    title: "Fleet",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Fleet",
    team: "Fleet",
    publicId: "Exchange\\M365FleetTeam",
    owner: "M365Fleet@microsoft.com",
    role: "*",
    tags: [],
    app: FleetApp,
    path: "/Fleet"
};
